var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"join-steps"},[_c('StepsHeader',{attrs:{"showStep":_vm.step}}),_c('div',{staticClass:"steps-content"},[_c(_vm.componentsMap[_vm.step],{tag:"component",on:{"back":_vm.back,"forward":_vm.forward}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }